import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../i18n/en';
import tr from '../i18n/tr';

const translations = { en, tr };
const STORAGE_KEY = 'legal-assistant-lang';

export const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'tr';
    } catch {
      return 'tr';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
    const htmlLang = lang === 'tr' ? 'tr-TR' : 'en-US';
    document.documentElement.lang = htmlLang;
  }, [lang]);

  /**
   * Look up a dotted key. `params` fills `{placeholder}` slots, e.g.
   * t('auth.idleWarning', { seconds: 42 }) against "… {seconds} saniye içinde …".
   */
  const t = (keyPath, params) => {
    const keys = keyPath.split('.');
    let obj = translations[lang] || translations.tr;
    for (const k of keys) {
      obj = obj?.[k];
      if (obj == null) break;
    }
    if (typeof obj !== 'string') return keyPath;
    if (!params) return obj;
    return obj.replace(/\{(\w+)\}/g, (match, name) => (
      Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match
    ));
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
